module.exports = __webpack_public_path__ + "assets/img/teacher (31).5904e076.png";